import { useState, useEffect } from 'react';

export default function usePageSize() {
  const [pageSize, setPageSize] = useState(getPageSize());

  function getPageSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      setPageSize(getPageSize());
    });
    return () => {
      window.removeEventListener('resize');
    };
  }, []);

  return pageSize;
}
